import { gql } from '@apollo/client/core';
import { richTextBlockFragment } from './rich-text-block.fragment';
import { buttonBlockFragment } from './button-block.fragment';
import { imageBlockFragment } from './image-block.fragment';

export const imageTextBlockFragment = gql`
  fragment ImageTextBlockFields on ImageTextBlock {
    entryTitle
    imagePosition
    content {
      ...RichTextBlockFields
    }
    image {
      ...ImageBlockFields
    }
    button {
      ...ButtonBlockFields
    }
  }
  ${richTextBlockFragment}
  ${imageBlockFragment}
  ${buttonBlockFragment}
`;
